export const PAYPAL_LIBRARY_URL =
  'https://www.paypal.com/sdk/js?components=messages&client-id={PAYPAL_CLIENT_ID}'
export const PAYPAL_CLIENT_ID_PLACEHOLDER = '{PAYPAL_CLIENT_ID}'
